export default "__VITE_ASSET__BiyAVt7L__"